import { CHECKOUT_REFRESH_PROTOCOL, isRefreshMessage } from "./protocol";
async function initializeCheckoutExtension() {
    const params = new URLSearchParams(location.search);
    const extensionId = params.get("extensionId");
    const parentOrigin = params.get("parentOrigin");
    if (!extensionId ||
        !parentOrigin ||
        window.parent === window ||
        new URL(parentOrigin).protocol !== "https:" ||
        new URL(parentOrigin).origin !== parentOrigin) {
        return;
    }
    if (!window.checkoutKitLoader) {
        throw new Error("BigCommerce extension SDK loader unavailable");
    }
    const sdk = await window.checkoutKitLoader.load("extension");
    const service = await sdk.initializeExtensionService({
        extensionId,
        parentOrigin,
        fixedHeight: 1,
    });
    const dispatched = new Set();
    window.addEventListener("message", (event) => {
        if (event.origin !== parentOrigin ||
            event.source !== window.parent ||
            !isRefreshMessage(event.data)) {
            return;
        }
        const { type, requestId } = event.data;
        if (type === "refresh") {
            if (!dispatched.has(requestId)) {
                service.post({ type: sdk.ExtensionCommandType.ReloadCheckout });
                dispatched.add(requestId);
            }
            window.parent.postMessage({ protocol: CHECKOUT_REFRESH_PROTOCOL, type: "dispatched", requestId }, parentOrigin);
        }
    });
}
void initializeCheckoutExtension().catch((error) => {
    console.error("Redo checkout extension failed to initialize", error);
});
//# sourceMappingURL=index.js.map